import { Modal } from '@virtidev/toolbox';
import styled, { css } from 'styled-components';

export const VHInfoPopupModal = styled(Modal)`
  .modal-header {
    /* padding: 0; */
  }
  .modal-box {
    max-width: 800px;
  }
  .modal-content {
    padding: 0;
  }
  .modal-footer {
    ${({ $hasFooterContent, theme: { color } }) => css`
      ${$hasFooterContent &&
      css`
        border-top: 1px solid ${color.midnight30};
      `}
    `}
  }
`;

export const VHInfoPopupModalFooterContent = styled.div`
  ${({ theme: { spacing } }) => css`
    padding: 0 ${spacing.sm};
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  `}
`;

export const ModalContent = styled.div`
  display: grid;
  row-gap: 1rem;
  text-align: center;
  ${({ theme: { spacing } }) => css`
    padding: ${spacing.xl};
    padding-top: 0;
    min-height: 0;
  `}
`;

export const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  justify-content: flex-start;
  ${({ theme: { spacing } }) => css`
    gap: ${spacing.md};
  `}
`;

export const StartButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 24px;
`;

export const TranslationLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5rem;
  margin-bottom: 2rem;
`;

export const Cols = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    gap: ${spacing.p5};
    grid-template-columns: 200px 1fr;
    min-height: 0;
  `}
`;

export const Heading = styled.h1`
  ${({ theme: { font, color } }) => css`
    ${font.h1}
    color: ${color.midnight};
    text-align: left;
  `}
`;

export const MainCol = styled.div`
  ${({ theme: { spacing } }) => css`
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: ${spacing.md};
  `}
`;

export const Shaded = styled.div`
  ${({ theme: { spacing, borderRadius, color } }) => css`
    background-color: ${color.blue50};
    border-radius: ${borderRadius.lg};
    text-align: left;
    padding: ${spacing.p5};
    white-space: pre-wrap;
  `}
`;

export const ClockIconWrapper = styled.div`
  position: relative;
  top: -2px;
`;

export const ShadedTime = styled.div`
  ${({ theme: { spacing, borderRadius, color, font } }) => css`
    ${font.h1}
    display: flex;
    gap: ${spacing.sm};
    align-items: center;
    border-radius: ${borderRadius.md};
    background-color: ${color.blue50};
    padding: ${spacing.p3} ${spacing.p5};
    text-align: left;
  `}
`;

export const SessionGoalHeader = styled.h2`
  ${({ theme: { fontWeight, spacing, color, font } }) => css`
    ${font.label}
    color: ${color.midnight5};
    margin-bottom: ${spacing.sm};
  `}
`;
export const SessionGoal = styled.div`
  ${({ theme: { spacing, borderRadius, color, font } }) => css`
    ${font.note}
    color: ${color.midnight10};
    display: flex;
    gap: ${spacing.p3};
    align-items: center;
    margin: ${spacing.sm} 0;
    &:last-child {
      margin-bottom: 0;
    }
  `}
`;